export const JOB_STATUS = {
  ERROR: 'error',
  FILE_ERROR: 'file_error',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
  UPDATED: 'updated',
  COMPLETED_WITH_ALERT: 'completed_with_alert',
};

export const EXTRACTION_STRATEGY = {
  FULL_PROFILE: 'full_profile',
  BIOMARKERS: 'biomarkers',
};
